import React from "react";
import { Filter } from "lucide-react";
import { DIRECTIONS, PAYMENT_METHODS } from "../types/profitTracking";

interface ProfitFiltersProps {
  countries: string[];
  filterCountry: string;
  filterPaymentMethod: string;
  filterDirection: string;
  filterDateFrom: string;
  filterDateTo: string;
  onFilterChange: (key: string, value: string) => void;
  onReset: () => void;
}

export const ProfitFilters: React.FC<ProfitFiltersProps> = ({
  countries,
  filterCountry,
  filterPaymentMethod,
  filterDirection,
  filterDateFrom,
  filterDateTo,
  onFilterChange,
  onReset,
}) => {
  return (
    <div className="flex flex-wrap gap-3 items-end p-4 bg-white rounded-xl border">
      <Filter size={16} className="text-gray-400" />

      <div>
        <label className="block text-xs text-gray-500">Pays</label>
        <select
          value={filterCountry}
          onChange={(e) => onFilterChange("country", e.target.value)}
          className="px-2 py-1.5 text-sm rounded-lg border"
        >
          <option value="">Tous</option>
          {countries.map((c) => (
            <option key={c} value={c}>
              {c}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label className="block text-xs text-gray-500">Moyen de paiement</label>
        <select
          value={filterPaymentMethod}
          onChange={(e) => onFilterChange("paymentMethod", e.target.value)}
          className="px-2 py-1.5 text-sm rounded-lg border"
        >
          <option value="">Tous</option>
          {PAYMENT_METHODS.map((pm) => (
            <option key={pm} value={pm}>
              {pm}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label className="block text-xs text-gray-500">Direction</label>
        <select
          value={filterDirection}
          onChange={(e) => onFilterChange("direction", e.target.value)}
          className="px-2 py-1.5 text-sm rounded-lg border"
        >
          <option value="">Toutes</option>
          {DIRECTIONS.map((d) => (
            <option key={d.value} value={d.value}>
              {d.label}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label className="block text-xs text-gray-500">Du</label>
        <input
          type="date"
          value={filterDateFrom}
          onChange={(e) => onFilterChange("dateFrom", e.target.value)}
          className="px-2 py-1.5 text-sm rounded-lg border"
        />
      </div>

      <div>
        <label className="block text-xs text-gray-500">Au</label>
        <input
          type="date"
          value={filterDateTo}
          onChange={(e) => onFilterChange("dateTo", e.target.value)}
          className="px-2 py-1.5 text-sm rounded-lg border"
        />
      </div>

      <button onClick={onReset} className="px-3 py-1.5 text-sm text-gray-500 rounded-lg border hover:bg-gray-50">
        Réinitialiser
      </button>
    </div>
  );
};
